import React, { FC, useCallback, useMemo } from 'react';
import { Button, Form, Input, Modal, Select } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import TextArea from 'antd/lib/input/TextArea';
import OWRadioGroup from '../ow_radio_group/OWRadioGroup';
import { StepInputTypes } from '../../utils/TroubleshootingUtils';

const FORM_NAME = 'troubleshooting-step-form';

const TroubleshootingStepModal: FC<any> = ({ step, onCancel, onSuccess }): React.ReactElement => {
	const [form] = useForm();

	const inputRequired = Form.useWatch('inputRequired', form);

	const isUpdate = useMemo(() => !!nullSafeGet('orderingId', step), [step]);

	const title = useMemo(() => (isUpdate ? 'Update Step' : 'Add Step'), [isUpdate]);

	const onSubmit = useCallback(
		(values) => {
			onSuccess({
				stepType: 'message',
				...(step || {}),
				...values,
			});
		},
		[onSuccess, step]
	);

	return (
		<Modal
			visible={true}
			width={600}
			title={title}
			closable
			onCancel={onCancel}
			forceRender
			footer={[
				<Button onClick={onCancel} size="large">
					Cancel
				</Button>,
				<Button
					type="primary"
					size="large"
					style={{ marginLeft: '16px' }}
					key="submit"
					htmlType="submit"
					form={FORM_NAME}
				>
					{title}
				</Button>,
			]}
		>
			<Form form={form} id={FORM_NAME} layout="vertical" initialValues={step} onFinish={onSubmit}>
				<Form.Item
					name="title"
					label="Title"
					rules={[
						{
							required: true,
							message: `Please enter title`,
						},
					]}
				>
					<Input style={{ width: '100%' }} />
				</Form.Item>
				<Form.Item name="description" label="Description">
					<TextArea style={{ width: '100%' }} />
				</Form.Item>
				<Form.Item name="canProceedToNextStep" label="Allowed to Next Step" initialValue={false}>
					<OWRadioGroup
						valueAccessor={(item) => item.value}
						renderRecord={(item) => item.label}
						items={[
							{
								label: 'Yes',
								value: true,
							},
							{
								label: 'No',
								value: false,
							},
						]}
					/>
				</Form.Item>
				<Form.Item name="inputRequired" label="Input Required" initialValue={false}>
					<OWRadioGroup
						valueAccessor={(item) => item.value}
						renderRecord={(item) => item.label}
						items={[
							{
								label: 'Yes',
								value: true,
							},
							{
								label: 'No',
								value: false,
							},
						]}
					/>
				</Form.Item>
				{inputRequired ? (
					<Form.Item name="inputType" label="Input Type">
						<Select style={{ width: '100%' }}>
							{StepInputTypes.map((f) => (
								<Select.Option key={f.value} value={f.value}>
									{f.label}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				) : null}
			</Form>
		</Modal>
	);
};

export default TroubleshootingStepModal;
